import { I18nComponente } from "@/types/gerais"

export const OHeaderi18n: I18nComponente = {
  "pt-BR": {
    timesheet: "Timesheet",
    usuarios: "usuários",
    gestaoDeTravamentos: "gestão de travamentos",
    importacoes: "importações",
    sair: "sair",
    acompanhamento: "acompanhamento",
    projetos: "projetos",
    recursos: "recursos",
    profissionais: "profissionais",
    tiposDeAtividade: "tipos de atividade",
    estatisticas: "estatísticas"
  },
  "es-CO": {
    timesheet: "Timesheet",
    usuarios: "usuarios",
    gestaoDeTravamentos: "control de congelamientos",
    importacoes: "importaciones",
    sair: "salir",
    acompanhamento: "agenda",
    projetos: "proyectos",
    recursos: "recursos",
    profissionais: "profesionales",
    tiposDeAtividade: "tipos de actividad",
    estatisticas: "estadísticas"
  }
}
